import { getConfig } from '@b2ag/micro-front-tools'
import { appBrands, type AppBrand } from './brands'

export let currentAppBrand: AppBrand

export function getCurrentAppBrand(): AppBrand {
  return getConfig('APP_CONTEXT') || appBrands.default
}

currentAppBrand = getCurrentAppBrand()

const isCurrentBrand = (brand: AppBrand) => currentAppBrand === brand

export const isAladin = isCurrentBrand(appBrands.Aladin)
export const isFarmi = isCurrentBrand(appBrands.Farmi)
export const isEpisens = isCurrentBrand(appBrands.Episens)
export const isCountrymalt = isCurrentBrand(appBrands.Countrymalt)
